<template>
    <div class="page bank-account-edit-page">
        <div class="page-body">
            <span>轉帳傳票</span>
            <span>{{ $store.getters["account/company"] }}</span>
            傳票日期
            <span>{{ pageData.dat | dateFormater("YYYY-MM-dd") }}</span>
            <span>傳票號碼 {{ pageData.vono }}</span>
            幣別：
            <span>{{ getCurrencyName(pageData.cny) }}</span>
            <table>
                <tr>
                    <td>會計科目</td>
                    <td>摘要</td>
                    <td>借方金額</td>
                    <td>貸方金額</td>
                </tr>
                <tr v-for="element in pageData.accountItems" :key="element.sno">
                    <td>
                        <span>{{ element.accnonam }}</span>
                    </td>
                    <td>
                        <span>{{ element.content }}</span>
                    </td>
                    <td>
                        <span>{{ element.crD_NTD }}</span>
                    </td>
                    <td>
                        <span>{{ element.deB_NTD }}</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">合計</td>
                    <td>{{ getVoucherCRDAmount }}</td>
                    <td>{{ getVoucherDEBAmount }}</td>
                </tr>
            </table>

            <span>製表人：{{ pageData.crT_USR }}{{ pageData.dat | dateFormater("YYYY-MM-dd") }}</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pageData: {
                sno: null,
                mno: null,
                vono: null,
                unT_NBR: null,
                dat: null,
                mem: null,
                cny: null,
                voucherType: this.voucherType,
                unt: null,
                cnl: false,
                accountItems: [],
            },
            currencyList: [],
        };
    },
    computed: {
        getVoucherCRDAmount() {
            if (this.pageData.accountItems) {
                return this.pageData.accountItems.reduce((accumulator, currentValue) => accumulator + currentValue.crD_NTD, 0);
            }

            return 0;
        },
        getVoucherDEBAmount() {
            if (this.pageData.accountItems) {
                return this.pageData.accountItems.reduce((accumulator, currentValue) => accumulator + currentValue.deB_NTD, 0);
            }

            return 0;
        },
    },
    created() {
        // 取得幣別下拉選單
        this.$api({
            url: '/BankAccountSettingPage/GetCurrencyOptions',
            method: 'GET',
        })
            // 取得成功
            .then((resp) => {
                // 更新資料
                this.currencyList = resp.data.options;
                this.pageData = this.$route.params.data;
            });
    },
    methods: {
        getCurrencyName(code) {
            if (this.currencyList.length > 0) {
                return this.currencyList.find((x) => x.cny === code).cnynam;
            }

            return '';
        },
    },
};
</script>
